import { Glyph } from "../../types";

const SvgUk: Glyph = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path fill="#012169" d="M0 0h512v512H0z" />
    <path d="M0 0L512 512M512 0L0 512" stroke="#fff" strokeWidth="120" strokeLinecap="butt" />
    <path d="M0 0L512 512M512 0L0 512" stroke="#C8102E" strokeWidth="60" strokeLinecap="butt" />
    <path fill="#fff" d="M0 206h512v100H0zM206 0h100v512H206z" />
    <path fill="#C8102E" d="M0 231h512v50H0zM231 0h50v512H231z" />
  </svg>
);

export default SvgUk;
